<button
  type="button"
  class="btn fw-bold"
  [class]="marginClass"
  (click)="back()"
>
  <i-bs name="chevron-left" width="24" height="24"> </i-bs>
</button>
